
export enum PaymentMethodTypes {
  CreditCard = "CC",
  IBAN = "IBAN",
  Cheque = "Cheque"
}